import React from 'react';

/**
 * Formats a DSL query (string or object) for display
 */
export function formatAgentDslQuery(value) {
  if (value == null) {
    return '-';
  }
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}


/**
 * Builds the complete accordion info section for agentic search results
 */
export function getAgenticInfo(generatedDslQuery) {
  return (
    <>
      <div style={{ marginTop: 16 }}>
        <h3>Generierte Query:</h3>
      </div>
      <pre className="agentic-info-dsl-query">
        {formatAgentDslQuery(generatedDslQuery)}
      </pre>
    </>
  );
}
